import { render, staticRenderFns } from "./editDenyReasonDialog.vue?vue&type=template&id=0053221c&scoped=true&"
import script from "./editDenyReasonDialog.vue?vue&type=script&lang=js&"
export * from "./editDenyReasonDialog.vue?vue&type=script&lang=js&"
import style0 from "./editDenyReasonDialog.vue?vue&type=style&index=0&id=0053221c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0053221c",
  null
  
)

export default component.exports